import { render, staticRenderFns } from "./EventPics.vue?vue&type=template&id=1af5a340&scoped=true&"
import script from "./EventPics.vue?vue&type=script&lang=js&"
export * from "./EventPics.vue?vue&type=script&lang=js&"
import style0 from "./EventPics.vue?vue&type=style&index=0&id=1af5a340&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af5a340",
  null
  
)

export default component.exports